module.exports = __webpack_public_path__ + "img/bottom-img.6e1f8196.png";